import type { OrgChartAssistantNode, OrgChartNodeOrAssistant } from "@domains/org-chart/shared/orgChartSchemas.ts";

const NO_ASSISTANTS: OrgChartAssistantNode[] = [];

export function getOrgChartAssistants(node: OrgChartNodeOrAssistant): OrgChartAssistantNode[] {
    return "assistants" in node ? node.assistants : NO_ASSISTANTS;
}
